import React, {Fragment} from 'react';
import {HashRouter} from 'react-router-dom';
import DevTools from 'mobx-react-devtools';
import App from './app/App';

const Root = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <Fragment>
      {
        isDevelopment && <DevTools />
      }
      <HashRouter>
        <App />
      </HashRouter>
    </Fragment>
  );
};

export default Root;


// WEBPACK FOOTER //
// ./src/Root.js